import { createSlice } from "@reduxjs/toolkit";
import { fetchClientJournal } from "../thunks/clientJournalThunk";

const clientJournalSlice = createSlice({
  name: "clientJournal",
  initialState: {
    journal: null,
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchClientJournal.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchClientJournal.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.journal = action.payload;
      })
      .addCase(fetchClientJournal.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export default clientJournalSlice.reducer;
